import Vue from 'vue';
import Vuex from 'vuex';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";

Vue.use(Vuex)

const app = initializeApp({
    apiKey: "AIzaSyD18cTsWAJ_EHtJkcQnLx8XOPpYA6Gzr0k",
    authDomain: "csf-site-a979e.firebaseapp.com",
    projectId: "csf-site-a979e",
    storageBucket: "csf-site-a979e.appspot.com",
    messagingSenderId: "950006402791",
    appId: "1:950006402791:web:2ae79455b023bffe115c42"
});

const Storage = getStorage();
const StorageListRef = ref(Storage, '/');
const DB = getFirestore(app);

function getColectionFromDatabase(c) {
	return getDocs(collection(DB, c));
}
function getDocFromDatabase(c, d) {
	return getDoc(doc(DB, c, d));
}
function setLS(key, value) {
	localStorage.setItem(key, JSON.stringify(value));
}
function getLS(key) {
	return JSON.parse(localStorage.getItem(key));
}
// function removeFromLs(key) {
// 	localStorage.removeItem(key);
// }

export default new Vuex.Store({
    namespaced: true,
    state: {
        selectedLang: 'ua',
        categories: [],
        courses: [],
        imageStorage: [],
        metaInfo: {},
        pagesContent: {
            home: '',
            about: '',
            courses: '',
            franchise: '',
            contacts: '',
            blog: '',
            terms: '',
            gallery: '',
            order: '',
            streams: '',
            general: ''
        }
    },
    getters: {
        getMetaInfo(state) {
            return state.metaInfo;
        },
        getImageStorage(state) {
            return state.imageStorage;
        },
        getSelectedLang(state) {
            return state.selectedLang;
        },
        getCategories(state) {
            return state.categories;
        },
        getCourses(state) {
            return state.courses;
        },
        getHomePageContent(state) {
            return state.pagesContent.home;
        },
        getAboutPageContent(state) {
            return state.pagesContent.about;
        },
        getGalleryPageContent(state) {
            return state.pagesContent.gallery;
        },
        getOrderPageContent(state) {
            return state.pagesContent.order;
        },
        getStreamsPageContent(state) {
            return state.pagesContent.streams;
        },
        getTermsPageContent(state) {
            return state.pagesContent.terms;
        },
        getFranchisePageContent(state) {
            return state.pagesContent.franchise;
        },
        getCoursesPageContent(state) {
            return state.pagesContent.courses;
        },
        getContactsPageContent(state) {
            return state.pagesContent.contacts;
        },
        getGeneralPageContent(state) {
            return state.pagesContent.general;
        },
        getCategoryById: (state) => (id) => {
            return state.categories.filter((el) => {
                return (el.id == id);
            })[0];
        },
        getCoursesByCategoryId: (state) => (id) => {
            return state.courses.filter((el) => {
                return (el.category == id);
            });
        },
        getCourseById: (state) => (id) => {
            return state.courses.filter((el) => {
                return (el.code == id);
            })[0];
        }
        // isProductInCart: (state) => (productId) => {
        //     return state.productsInCart.some((product) => {
        //         return (product.code == productId);
        //     });
        // }
    },
    mutations: {
    },
    actions: {
        setLang(context, lang) {
            context.state.selectedLang = lang;
            localStorage.setItem('lang', lang);
        },
        sendOrder(context, order) {
            return setDoc(doc(DB, 'Orders', order.docName), order);
        },
        fetchCategories(context) {
			getColectionFromDatabase('Categories').then((data) => {
				data.forEach((element) => {
					context.state.categories.push(element.data());
				})
			});
		},
        fetchCourses(context) {
			getColectionFromDatabase('Courses').then((data) => {
				data.forEach((element) => {
					context.state.isCatalogLoading = false;
					context.state.courses.push(element.data());
				})
			});
		},
        fetchStaticContent(context) {
			getDocFromDatabase('Pages', 'Home').then((data) => {
				context.state.pagesContent.home = data.data();
			});
			getDocFromDatabase('Pages', 'Courses').then((data) => {
				context.state.pagesContent.courses = data.data();
			});
			getDocFromDatabase('Pages', 'About').then((data) => {
				context.state.pagesContent.about = data.data();
			});
			getDocFromDatabase('Pages', 'Terms').then((data) => {
				context.state.pagesContent.terms = data.data();
			});
			getDocFromDatabase('Pages', 'Contacts').then((data) => {
				context.state.pagesContent.contacts = data.data();
			});
            getDocFromDatabase('Pages', 'Gallery').then((data) => {
				context.state.pagesContent.gallery = data.data();
			});
            getDocFromDatabase('Pages', 'Streams').then((data) => {
				context.state.pagesContent.streams = data.data();
			});
			getDocFromDatabase('Pages', 'Franchise').then((data) => {
				context.state.pagesContent.franchise = data.data();
			});
			getDocFromDatabase('Pages', 'Order').then((data) => {
				context.state.pagesContent.order = data.data();
			});
			getDocFromDatabase('Pages', 'GeneralInfo').then((data) => {
				context.state.pagesContent.general = data.data();
			});
		},
        fetchMetaInfo(context) {
            getDocFromDatabase('SEO', 'Meta').then((data) => {
				context.state.metaInfo = data.data();
			});
        },
        fetchImageStorage(context) {
            listAll(StorageListRef)
                .then((res) => {
                    let storage = new Array(res.prefixes.length + 1);
                    let i = -1;
                    res.prefixes.forEach(prefixe => {
                        i++;
                        storage[i] = {
                            name: prefixe.name,
                            list: []
                        }
                        listAll(prefixe)
                            .then(prefixeRes => {
                                prefixeRes.items.forEach(image => {
                                    getDownloadURL(image)
                                        .then(url => {
                                            storage[i].list.push(url);
                                        });
                                });
                            })
                    });
                    storage[i+1] = {
                        name: 'Other',
                        list: []
                    }
                    res.items.forEach((image) => {
                        getDownloadURL(image)
                            .then(url => {
                                storage[i + 1].list.push(url);
                            });
                    });
                    context.state.imageStorage = storage;
                });
        }
    },
    modules: {
        
    }
});
